var map = {
	"./af-ZA.svg": 2356,
	"./ar-EG.svg": 6691,
	"./ar-MA.svg": 4645,
	"./bg.svg": 110,
	"./cs.svg": 9301,
	"./de-AT.svg": 3276,
	"./de-CH.svg": 6182,
	"./de.svg": 9858,
	"./el.svg": 1240,
	"./en-AU.svg": 5285,
	"./en-NZ.svg": 2455,
	"./en-US.svg": 7055,
	"./en.svg": 634,
	"./es-AR.svg": 2985,
	"./es-PR.svg": 7354,
	"./es.svg": 5631,
	"./et-EE.svg": 1219,
	"./fi.svg": 9484,
	"./fil-PH.svg": 1253,
	"./fr-CH.svg": 5889,
	"./fr.svg": 9015,
	"./he-IL.svg": 3760,
	"./hu-HU.svg": 6778,
	"./it.svg": 1724,
	"./lt-LT.svg": 1156,
	"./lv-LV.svg": 4100,
	"./pl.svg": 6735,
	"./pt-BR.svg": 8252,
	"./ro.svg": 8726,
	"./ru.svg": 9708,
	"./sk-SK.svg": 2796,
	"./sr.svg": 4468,
	"assets/images/flags/af-ZA.svg": 2356,
	"assets/images/flags/ar-EG.svg": 6691,
	"assets/images/flags/ar-MA.svg": 4645,
	"assets/images/flags/bg.svg": 110,
	"assets/images/flags/cs.svg": 9301,
	"assets/images/flags/de-AT.svg": 3276,
	"assets/images/flags/de-CH.svg": 6182,
	"assets/images/flags/de.svg": 9858,
	"assets/images/flags/el.svg": 1240,
	"assets/images/flags/en-AU.svg": 5285,
	"assets/images/flags/en-NZ.svg": 2455,
	"assets/images/flags/en-US.svg": 7055,
	"assets/images/flags/en.svg": 634,
	"assets/images/flags/es-AR.svg": 2985,
	"assets/images/flags/es-PR.svg": 7354,
	"assets/images/flags/es.svg": 5631,
	"assets/images/flags/et-EE.svg": 1219,
	"assets/images/flags/fi.svg": 9484,
	"assets/images/flags/fil-PH.svg": 1253,
	"assets/images/flags/fr-CH.svg": 5889,
	"assets/images/flags/fr.svg": 9015,
	"assets/images/flags/he-IL.svg": 3760,
	"assets/images/flags/hu-HU.svg": 6778,
	"assets/images/flags/it.svg": 1724,
	"assets/images/flags/lt-LT.svg": 1156,
	"assets/images/flags/lv-LV.svg": 4100,
	"assets/images/flags/pl.svg": 6735,
	"assets/images/flags/pt-BR.svg": 8252,
	"assets/images/flags/ro.svg": 8726,
	"assets/images/flags/ru.svg": 9708,
	"assets/images/flags/sk-SK.svg": 2796,
	"assets/images/flags/sr.svg": 4468
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3492;